export default __webpack_public_path__ + "static/media/grid6.50019208.png";